<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
            >
                <v-icon>more_horiz</v-icon>
            </v-btn>
        </template>
        <v-list flat>
            <v-list-item-group>

                <v-list-item :to="{ name: 'Users.Details', params: {id: item.id}}">
                    <v-list-item-title>Расширенное инфо</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'Products.List', query: { seller: item.id } }">
                    <v-list-item-title>Товары</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'Orders', query: { seller: item.id } }">
                    <v-list-item-title>Сделки</v-list-item-title>
                </v-list-item>
                <v-list-item @click="edit">
                    <v-list-item-title>Быстрое редактирование</v-list-item-title>
                </v-list-item>
                <v-list-item @click="remove">
                    <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>


                <!--<v-list-item :to="{ name: 'Products.Copy', params: {id: item.id}}">-->
                    <!--<v-list-item-title>{{ $t('copy') }}</v-list-item-title>-->
                <!--</v-list-item>-->

                <!--<v-list-item :href="productUrl">-->
                    <!--<v-list-item-title>{{ $t('toProduct') }}</v-list-item-title>-->
                <!--</v-list-item>-->

                <!--<v-list-item @click="showDeleteSnack">-->
                    <!--<v-list-item-title>{{ $t('remove') }}</v-list-item-title>-->
                <!--</v-list-item>-->

            </v-list-item-group>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "TableActions",
        props:['item'],
        data() {
            return {

            }
        },
        methods: {
            remove() {
                this.$emit('remove', this.item)
            },
            edit() {
                this.$emit('edit', this.item)
            }
        },
    }
</script>

<style scoped>

</style>